import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App.vue';
import { applyOrientationPolyfill } from './components/OrientationPolyfill';
import DirectPortal from './components/DirectPortal';

import "./assets/main.css";
import 'preline';

// Apply Screen Orientation API polyfill
applyOrientationPolyfill();

// Register the direct portal directive
Vue.use(DirectPortal);

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router, // Add the router to your Vue instance
  store,
  render: h => h(App)
})
